module.exports = __webpack_public_path__ + "img/背景.dc755398.png";